(() => {
  if (window.rnfStoreLinkAnimationInstalled) return;
  window.rnfStoreLinkAnimationInstalled = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Map();
  const wheels = new Map();
  let touchedLink = null;
  let touchedAt = 0;

  const findLink = target => target instanceof Element
    ? target.closest('a[data-rnf-store-link]')
    : null;

  function wheelFor(link) {
    if (wheels.has(link)) return wheels.get(link);
    const rotor = link.querySelector('.rnf-store-link__wheel-spin');
    if (!rotor) return null;
    const wheel = { link, rotor, angle: 0, lastTime: 0, frame: 0, hovered: false, focused: false, touched: false };
    wheels.set(link, wheel);
    return wheel;
  }

  function syncWheel(wheel) {
    const active = !reducedMotion.matches && !document.hidden && wheel.link.isConnected
      && (wheel.hovered || wheel.focused || wheel.touched);
    if (!active) {
      window.cancelAnimationFrame(wheel.frame);
      wheel.frame = 0;
      wheel.lastTime = 0;
      return;
    }
    if (wheel.frame) return;
    wheel.lastTime = performance.now();
    const spin = now => {
      if (reducedMotion.matches || document.hidden || !wheel.link.isConnected
        || !(wheel.hovered || wheel.focused || wheel.touched)) {
        wheel.frame = 0;
        wheel.lastTime = 0;
        return;
      }
      wheel.angle = (wheel.angle + Math.min(now - wheel.lastTime, 64) * .4) % 360;
      wheel.lastTime = now;
      // SVG user coordinates keep the original wheel fixed on its measured axis.
      wheel.rotor.setAttribute('transform', `rotate(${wheel.angle.toFixed(3)} 1301.75 230.5)`);
      wheel.frame = window.requestAnimationFrame(spin);
    };
    wheel.frame = window.requestAnimationFrame(spin);
  }

  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    const link = findLink(event.target);
    if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
    const wheel = wheelFor(link);
    if (!wheel) return;
    wheel.hovered = true;
    syncWheel(wheel);
  });

  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    const link = findLink(event.target);
    if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
    const wheel = wheels.get(link);
    if (!wheel) return;
    wheel.hovered = false;
    syncWheel(wheel);
  });

  document.addEventListener('focusin', event => {
    const link = findLink(event.target);
    if (!link) return;
    const wheel = wheelFor(link);
    if (!wheel) return;
    wheel.focused = link.matches(':focus-visible');
    syncWheel(wheel);
  });

  document.addEventListener('focusout', event => {
    const link = findLink(event.target);
    if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
    const wheel = wheels.get(link);
    if (!wheel) return;
    wheel.focused = false;
    syncWheel(wheel);
  });

  document.addEventListener('pointerdown', event => {
    touchedLink = event.pointerType === 'touch'
      ? findLink(event.target)
      : null;
    touchedAt = performance.now();
  }, { passive: true });

  document.addEventListener('pointercancel', () => { touchedLink = null; }, { passive: true });

  document.addEventListener('click', event => {
    const link = findLink(event.target);
    if (!link || event.defaultPrevented || event.button !== 0 || event.detail === 0
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      || link.hasAttribute('download') || (link.target && link.target !== '_self')
      || reducedMotion.matches) return;

    if (link !== touchedLink || performance.now() - touchedAt > 1200) return;
    const wheel = wheelFor(link);
    if (!wheel) return;
    event.preventDefault();
    // Keep the mobile sheet visible for a short wheel spin before normal navigation.
    event.stopPropagation();
    if (pending.has(link)) return;

    const destination = link.href;
    link.classList.add('is-touch-opening');
    wheel.touched = true;
    syncWheel(wheel);
    const timer = window.setTimeout(() => {
      pending.delete(link);
      window.location.assign(destination);
    }, 480);
    pending.set(link, timer);
  }, true);

  reducedMotion.addEventListener('change', () => wheels.forEach(syncWheel));
  document.addEventListener('visibilitychange', () => wheels.forEach(syncWheel));
  window.addEventListener('pagehide', () => {
    for (const wheel of wheels.values()) {
      window.cancelAnimationFrame(wheel.frame);
      wheel.frame = 0;
      wheel.lastTime = 0;
    }
  });

  window.addEventListener('pageshow', () => {
    for (const [link, timer] of pending) {
      window.clearTimeout(timer);
      link.classList.remove('is-touch-opening');
    }
    pending.clear();
    for (const wheel of wheels.values()) {
      window.cancelAnimationFrame(wheel.frame);
      wheel.frame = 0;
      wheel.lastTime = 0;
      wheel.hovered = false;
      wheel.focused = false;
      wheel.touched = false;
    }
    document.querySelectorAll('a[data-rnf-store-link].is-touch-opening').forEach(link => {
      link.classList.remove('is-touch-opening');
    });
    touchedLink = null;
  });
})();
